export class APIsEndPoints {
    // public static readonly BASE_URL: string = 'http://ardmoresafetyrating.marinepals.com:3001/v1';
    // public static readonly BASE_URL_V2: string = 'http://ardmoresafetyrating.marinepals.com:3001/v2';
     public static readonly BASE_URL: string = 'http://ardmoredev.marinepals.com:3001/v1';
     public static readonly BASE_URL_V2: string = 'http://ardmoredev.marinepals.com:3001/v2';
    // public static readonly BASE_URL: string = 'http://localhost:3000/v1';
    // public static readonly BASE_URL_V2: string = 'http://localhost:3000/v2';
    // Auth APIs URLs
    public static readonly LOGIN = APIsEndPoints.BASE_URL + '/auth/login';
    public static readonly LOGOUT = APIsEndPoints.BASE_URL + '/auth/logout';
    public static readonly FORGOT_PASSWORD = APIsEndPoints.BASE_URL + '/auth/forgetPassword';
    public static readonly VALIDATE_TOKEN = APIsEndPoints.BASE_URL + '/auth/checkTokenValidity?token=';
    public static readonly CHANGE_PASSWORD = APIsEndPoints.BASE_URL + '/auth/changePassword';

    // Analtics APIs URLs
    public static readonly GET_LIST_ALL_SUGGESTION = APIsEndPoints.BASE_URL + '/ratings/listCrewRatingsByName';
    
    public static readonly GET_ALL_RATINGS = APIsEndPoints.BASE_URL + '/ratings/listRatings';
    public static readonly LIST_CREW_RATINGS = APIsEndPoints.BASE_URL + '/ratings/listCrewRatings';
    public static readonly GET_CREW_RATINGS = APIsEndPoints.BASE_URL + '/ratings/crewRatings';
    public static readonly GET_RATING_DETAILS = APIsEndPoints.BASE_URL + '/ratings/getRatingDetails';
    public static readonly GET_ALL_RANKS = APIsEndPoints.BASE_URL + '/ratings/getAllRanks';

    public static readonly GET_RATINGS_FIRM = APIsEndPoints.BASE_URL_V2 + '/ratings/listRatings';
    public static readonly GET_RATING_BY_FILTERS = APIsEndPoints.BASE_URL_V2 + '/ratings/ratingByfilters';
    public static readonly GET_QUESTIONS_AVG_RATING = APIsEndPoints.BASE_URL_V2 + '/ratings/ratingQuestionAvg';
    public static readonly GET_SETTINGS = APIsEndPoints.BASE_URL_V2 + '/setting';
}
